// Action types
export const PORTFOLIO_SHOW_LOADING_ACTION_RESET = 'PORTFOLIO_SHOW_LOADING_ACTION_RESET';
export const PORTFOLIO_SHOW_LOADING_ACTION_START_REQUEST = 'PORTFOLIO_SHOW_LOADING_ACTION_START_REQUEST';
export const PORTFOLIO_SHOW_LOADING_ACTION_SET_PORTFOLIO_LOADED = 'PORTFOLIO_SHOW_LOADING_ACTION_SET_PORTFOLIO_LOADED';
export const PORTFOLIO_SHOW_LOADING_ACTION_SET_METERS_LOADED = 'PORTFOLIO_SHOW_LOADING_ACTION_SET_METERS_LOADED';
export const PORTFOLIO_SHOW_LOADING_ACTION_METERS_DISPLAYED = 'PORTFOLIO_SHOW_LOADING_ACTION_METERS_DISPLAYED';
export const PORTFOLIO_SHOW_LOADING_ACTION_SET_RULES_LOADED = 'PORTFOLIO_SHOW_LOADING_ACTION_SET_RULES_LOADED';
export const PORTFOLIO_SHOW_LOADING_ACTION_SET_CONSUMED_DATA_LOADED = 'PORTFOLIO_SHOW_LOADING_ACTION_SET_CONSUMED_DATA_LOADED';
export const PORTFOLIO_SHOW_LOADING_ACTION_SET_GENERATED_DATA_LOADED = 'PORTFOLIO_SHOW_LOADING_ACTION_SET_GENERATED_DATA_LOADED';
export const PORTFOLIO_SHOW_LOADING_ACTION_SET_METER_DATA_BATCH_PROGRESS = 'PORTFOLIO_SHOW_LOADING_ACTION_SET_METER_DATA_BATCH_PROGRESS';
export const PORTFOLIO_SHOW_LOADING_ACTION_SET_TRADE_SUMMARY_PROGRESS = 'PORTFOLIO_SHOW_LOADING_ACTION_SET_TRADE_SUMMARY_PROGRESS';
export const PORTFOLIO_SHOW_LOADING_ACTION_MARK_FULLY_LOADED = 'PORTFOLIO_SHOW_LOADING_ACTION_MARK_FULLY_LOADED';
export const PORTFOLIO_SHOW_LOADING_ACTION_DATA_PREPARED = 'PORTFOLIO_SHOW_LOADING_ACTION_DATA_PREPARED';
export const PORTFOLIO_SHOW_LOADING_ACTION_RENDERING_DISPLAYED = 'PORTFOLIO_SHOW_LOADING_ACTION_RENDERING_DISPLAYED';
export const PORTFOLIO_SHOW_LOADING_ACTION_HIDE_OVERLAY = 'PORTFOLIO_SHOW_LOADING_ACTION_HIDE_OVERLAY';
export const PORTFOLIO_SHOW_LOADING_ACTION_SET_ERROR = 'PORTFOLIO_SHOW_LOADING_ACTION_SET_ERROR';
export const PORTFOLIO_SHOW_LOADING_ACTION_CANCEL_REQUEST = 'PORTFOLIO_SHOW_LOADING_ACTION_CANCEL_REQUEST';

export const PortfolioShowLoadingActions = Object.freeze({
  RESET: PORTFOLIO_SHOW_LOADING_ACTION_RESET,
  START_REQUEST: PORTFOLIO_SHOW_LOADING_ACTION_START_REQUEST,
  SET_PORTFOLIO_LOADED: PORTFOLIO_SHOW_LOADING_ACTION_SET_PORTFOLIO_LOADED,
  SET_METERS_LOADED: PORTFOLIO_SHOW_LOADING_ACTION_SET_METERS_LOADED,
  METERS_DISPLAYED: PORTFOLIO_SHOW_LOADING_ACTION_METERS_DISPLAYED,
  SET_RULES_LOADED: PORTFOLIO_SHOW_LOADING_ACTION_SET_RULES_LOADED,
  SET_CONSUMED_DATA_LOADED: PORTFOLIO_SHOW_LOADING_ACTION_SET_CONSUMED_DATA_LOADED,
  SET_GENERATED_DATA_LOADED: PORTFOLIO_SHOW_LOADING_ACTION_SET_GENERATED_DATA_LOADED,
  SET_METER_DATA_BATCH_PROGRESS: PORTFOLIO_SHOW_LOADING_ACTION_SET_METER_DATA_BATCH_PROGRESS,
  SET_TRADE_SUMMARY_PROGRESS: PORTFOLIO_SHOW_LOADING_ACTION_SET_TRADE_SUMMARY_PROGRESS,
  MARK_FULLY_LOADED: PORTFOLIO_SHOW_LOADING_ACTION_MARK_FULLY_LOADED,
  DATA_PREPARED: PORTFOLIO_SHOW_LOADING_ACTION_DATA_PREPARED,
  RENDERING_DISPLAYED: PORTFOLIO_SHOW_LOADING_ACTION_RENDERING_DISPLAYED,
  HIDE_OVERLAY: PORTFOLIO_SHOW_LOADING_ACTION_HIDE_OVERLAY,
  SET_ERROR: PORTFOLIO_SHOW_LOADING_ACTION_SET_ERROR,
  CANCEL_REQUEST: PORTFOLIO_SHOW_LOADING_ACTION_CANCEL_REQUEST,
});

// Loading states
export const PORTFOLIO_SHOW_LOADING_STATE_IDLE = 'PORTFOLIO_SHOW_LOADING_STATE_IDLE';
export const PORTFOLIO_SHOW_LOADING_STATE_LOADING_PORTFOLIO = 'PORTFOLIO_SHOW_LOADING_STATE_LOADING_PORTFOLIO';
export const PORTFOLIO_SHOW_LOADING_STATE_LOADING_METERS = 'PORTFOLIO_SHOW_LOADING_STATE_LOADING_METERS';
export const PORTFOLIO_SHOW_LOADING_STATE_METERS_LOADED = 'PORTFOLIO_SHOW_LOADING_STATE_METERS_LOADED';
export const PORTFOLIO_SHOW_LOADING_STATE_LOADING_RULES = 'PORTFOLIO_SHOW_LOADING_STATE_LOADING_RULES';
export const PORTFOLIO_SHOW_LOADING_STATE_RULES_LOADED = 'PORTFOLIO_SHOW_LOADING_STATE_RULES_LOADED';
export const PORTFOLIO_SHOW_LOADING_STATE_LOADING_CONSUMED = 'PORTFOLIO_SHOW_LOADING_STATE_LOADING_CONSUMED';
export const PORTFOLIO_SHOW_LOADING_STATE_LOADING_GENERATED = 'PORTFOLIO_SHOW_LOADING_STATE_LOADING_GENERATED';
export const PORTFOLIO_SHOW_LOADING_STATE_LOADING_TRADE_SUMMARY = 'PORTFOLIO_SHOW_LOADING_STATE_LOADING_TRADE_SUMMARY';
export const PORTFOLIO_SHOW_LOADING_STATE_PREPARING_DATA = 'PORTFOLIO_SHOW_LOADING_STATE_PREPARING_DATA';
export const PORTFOLIO_SHOW_LOADING_STATE_RENDERING = 'PORTFOLIO_SHOW_LOADING_STATE_RENDERING';
export const PORTFOLIO_SHOW_LOADING_STATE_COMPLETE = 'PORTFOLIO_SHOW_LOADING_STATE_COMPLETE';
export const PORTFOLIO_SHOW_LOADING_STATE_ERROR = 'PORTFOLIO_SHOW_LOADING_STATE_ERROR';
export const PORTFOLIO_SHOW_LOADING_STATE_CANCELLED = 'PORTFOLIO_SHOW_LOADING_STATE_CANCELLED';

export const PortfolioShowLoadingStates = Object.freeze({
  IDLE: PORTFOLIO_SHOW_LOADING_STATE_IDLE,
  LOADING_PORTFOLIO: PORTFOLIO_SHOW_LOADING_STATE_LOADING_PORTFOLIO,
  LOADING_METERS: PORTFOLIO_SHOW_LOADING_STATE_LOADING_METERS,
  METERS_LOADED: PORTFOLIO_SHOW_LOADING_STATE_METERS_LOADED,
  LOADING_RULES: PORTFOLIO_SHOW_LOADING_STATE_LOADING_RULES,
  RULES_LOADED: PORTFOLIO_SHOW_LOADING_STATE_RULES_LOADED,
  LOADING_CONSUMED: PORTFOLIO_SHOW_LOADING_STATE_LOADING_CONSUMED,
  LOADING_GENERATED: PORTFOLIO_SHOW_LOADING_STATE_LOADING_GENERATED,
  LOADING_TRADE_SUMMARY: PORTFOLIO_SHOW_LOADING_STATE_LOADING_TRADE_SUMMARY,
  PREPARING_DATA: PORTFOLIO_SHOW_LOADING_STATE_PREPARING_DATA,
  RENDERING: PORTFOLIO_SHOW_LOADING_STATE_RENDERING,
  COMPLETE: PORTFOLIO_SHOW_LOADING_STATE_COMPLETE,
  ERROR: PORTFOLIO_SHOW_LOADING_STATE_ERROR,
  CANCELLED: PORTFOLIO_SHOW_LOADING_STATE_CANCELLED,
});

/**
 * Message keys used by the loading overlay.
 */
export const LoadingMessageKeys = Object.freeze({
  NONE: 'none',
  LOADING_PORTFOLIO: 'loading_portfolio',
  PORTFOLIO_LOADED: 'portfolio_loaded',
  METERS_LOADED: 'meters_loaded',
  RULES_LOADED: 'rules_loaded',
  CONSUMED_DATA_LOADED: 'consumed_data_loaded',
  GENERATED_DATA_LOADED: 'generated_data_loaded',
  TRADE_SUMMARY_PROGRESS: 'trade_summary_progress',
  PREPARING_DATA: 'preparing_data',
  RENDERING: 'rendering',
  COMPLETE: 'complete',
});

/**
 * Stage keys used to identify individual loading stages for parallel tracking.
 * These are used in the activeStages and completedStages arrays.
 */
export const StageKeys = Object.freeze({
  IDLE: 'IDLE',
  PORTFOLIO: 'PORTFOLIO',
  METERS: 'METERS',
  RULES: 'RULES',
  CONSUMED_DATA: 'CONSUMED_DATA',
  GENERATED_DATA: 'GENERATED_DATA',
  TRADE_SUMMARY: 'TRADE_SUMMARY',
  DATA_PREPARED: 'DATA_PREPARED',
  DATA_RENDERED: 'DATA_RENDERED',
  ERROR: 'ERROR',
});

/**
 * Progress weight for each stage key. Weights represent each stage's share
 * of total work and sum to 100. Used by calculateProgress to compute dynamic
 * progress from completedStages and activeStages arrays.
 */
export const STAGE_PROGRESS = {
  [StageKeys.IDLE]: 0,
  [StageKeys.PORTFOLIO]: 5,
  [StageKeys.METERS]: 20,
  [StageKeys.RULES]: 10,
  [StageKeys.CONSUMED_DATA]: 10,
  [StageKeys.GENERATED_DATA]: 10,
  [StageKeys.TRADE_SUMMARY]: 20,
  [StageKeys.DATA_PREPARED]: 10,
  [StageKeys.DATA_RENDERED]: 15,
  [StageKeys.ERROR]: 0,
};

export const defaultInitialState = () => ({
  state: PortfolioShowLoadingStates.IDLE,
  activeStages: [],
  completedStages: [],
  metadata: {
    metersCount: 0,
    rulesCount: 0,
    meterBatchesLoaded: 0,
    meterBatchesTotal: 0,
    batchesLoaded: 0,
    batchesTotal: 0,
    error: null,
  },
  overlay: {
    progressBarValue: 0,
    messageKey: LoadingMessageKeys.NONE,
  },
});
